var Rx = require('ub_wrapped/rx');
var jQuery = require('jquery');
var _ = require('lodash');

var FakeTourTemplateBuilder =
  require('ub_legacy/lp/new-feature-tour/fake-tour-template-builder.js');

var fakeLocalStore = {
  _data: {},
  setItem: function(id, val) {
    this._data[id] = String(val);
    return this._data[id];
  },
  getItem: function(id) {
    return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
  },
  removeItem: function(id) {
    return delete this._data[id];
  }
};

var _getStore = function() {
  return window.hasOwnProperty('localStorage') ? window.localStorage : fakeLocalStore;
};

var _getTempStore = function() {
  return fakeLocalStore;
};

var Store     = _getStore()
  , TempStore = _getTempStore();

var NewFeatureTour = function(name, options) {
  this.name = name;
  this.openSelectorRole = options.openSelectorRole;
  this.inputSelectorRole = options.inputSelectorRole;
  this.templateBuilderConstructor = _.isFunction(options.templateBuilderConstructor) ?
    options.templateBuilderConstructor : FakeTourTemplateBuilder;
};

NewFeatureTour.prototype = (function() {
  var _getDisplayEventStream = function($openElm) {
    return new Rx.Observable.fromEvent($openElm, 'click')
      .filter(function(ev) {
        // This filter ensures that clicks to the mobile enabled toggle (a child of the
        // mobile switcher button) don't trigger the mobile tour.
        return $openElm[0] === ev.target;
      });
  };

  var _getInputEventStream = function($inputElm) {
    return Rx.Observable.fromEvent($inputElm, 'change');
  };

  var _getStorageKey = function(name) { return name; };

  var _getTempStorageKey = function(name) { return name + "-temp"; };

  var setDialogViewedState = function(name, state) {
    Store.setItem(_getStorageKey(name), state);
  };

  var setDialogViewedThisSessionState = function(name) {
    TempStore.setItem(_getTempStorageKey(name), true);
  };

  return {
    init: function() {
      this.$openElm = jQuery("[data-role='" + this.openSelectorRole + "']");

      var openTourStream = _getDisplayEventStream(this.$openElm);

      var onClose = function() {
        setDialogViewedThisSessionState(this.name);
      };

      openTourStream.subscribe(function() {
        if (this.shouldShowTour() && this.shouldShowTourThisSession()) {
          this.templateBuilder = new this.templateBuilderConstructor();
          this.templateBuilder.beforeRender();
          this.templateBuilder.render(onClose.bind(this));
          this.templateBuilder.afterRender();

          this.$inputElm = jQuery("[data-role='" + this.inputSelectorRole + "']");

          _getInputEventStream(this.$inputElm).subscribe(function(ev) {
            setDialogViewedState(this.name, ev.target.checked);
          }.bind(this));
        }
      }.bind(this));
    },

    shouldShowTour: function() {
      return Store.getItem(_getStorageKey(this.name)) !== 'true';
    },

    shouldShowTourThisSession: function() {
      return TempStore.getItem(_getTempStorageKey(this.name)) !== 'true';
    }
  };
  })();

module.exports = NewFeatureTour;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/new-feature-tour.js
// module id = 1047
// module chunks = 0